<loading [isFixed]="true" [isAbsolute]="false" [isLoading]="isLoading" [isFullSize]="true"></loading>
<!-- <div class="row" *ngIf="columnHeader.hasOwnProperty('Actions')"></div> -->
<div class="header-actions">
  <div class="col-md-10 header-left-section">
    <div class="search-input">
      <mat-form-field>
        <input class="inputFilter" matInput [(ngModel)]="filtroInput" placeholder="Filtro" (keyup)="applyFilter($event)"/>
      </mat-form-field>
    </div>
    <div class="header-actions-buttons">
      <div class="btn-mat-icon-group">
        <mat-icon aria-hidden="false" class="btn-buscar" (click)="applyFilter()">search</mat-icon>
        <mat-icon aria-hidden="false" class="btn-limpiar" (click)="refreshFilter()">cancel</mat-icon>
      </div>
    </div>
  </div>
</div>

<div class="table-section">
  <table #miTabla mat-table [dataSource]="mainDataSource" matSort class="mat-elevation-z8">
    <ng-container
      [matColumnDef]="dataKeys"
      *ngFor="let dataKeys of objectKeys(columnHeader)"
    >
    
      <ng-container [ngSwitch]="dataKeys">
        <ng-container *ngSwitchDefault>
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div style="display: flex; flex-direction: column;">
              <div style="display: flex; flex-direction: row; align-items: center;">

                <div>
                  {{ columnHeader[dataKeys].displayName }}
                </div>
                
                <button matMenuTriggerRestoreFocus="false" *ngIf="columnHeader[dataKeys].filterable" mat-icon-button [matMenuTriggerFor]="filterMenu" (click)="setCurrentColumn(dataKeys)">
                  <!-- <mat-icon>filter_list</mat-icon> -->
                  <mat-icon *ngIf="!columnHeader[dataKeys].activeFilter" >filter_alt_on</mat-icon>
                  <mat-icon *ngIf="columnHeader[dataKeys].activeFilter" >filter_alt_off</mat-icon>
                </button>
  
              </div>

              <div>
                <span *ngIf="columnHeader[dataKeys].activeFilter">({{ columnHeader[dataKeys].activeFilter }})</span>
              </div>

            </div>
          </th>
          <td  mat-cell *matCellDef="let element; let i = index">
            <div >{{ element[dataKeys] }}</div>
          </td>
        </ng-container>
  
        <ng-container *ngSwitchCase="'StatusMapixDownloadRequest'">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div style="display: flex; flex-direction: column;">
              <div style="display: flex; flex-direction: row; align-items: center;">

                <div>
                  {{ columnHeader[dataKeys].displayName }}
                </div>
                
                <button matMenuTriggerRestoreFocus="false" *ngIf="columnHeader[dataKeys].filterable" mat-icon-button [matMenuTriggerFor]="filterMenu" (click)="setCurrentColumn(dataKeys)">
                  <mat-icon *ngIf="!columnHeader[dataKeys].activeFilter" >filter_alt_on</mat-icon>
                  <mat-icon *ngIf="columnHeader[dataKeys].activeFilter" >filter_alt_off</mat-icon>
                </button>
  
              </div>

              <div>
                <span *ngIf="columnHeader[dataKeys].activeFilter">({{ columnHeader[dataKeys].activeFilter }})</span>
              </div>
              
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index">
                <div class="status-container" (click)="downloadReport(element)">
                    <ng-container [ngSwitch]="element[dataKeys]">
                        <mat-icon *ngSwitchCase="'Terminado'" color="primary" matTooltip="Terminado">check_circle</mat-icon>
                        <mat-spinner *ngSwitchCase="'En proceso'" diameter="24" matTooltip="En proceso"></mat-spinner>
                        <mat-icon *ngSwitchCase="'Error'" color="warn" matTooltip="Error">error</mat-icon>
                    </ng-container>
                </div>
           </td>
        </ng-container>

      </ng-container>
    </ng-container>
  
    
    <tr class="mat-row" *matNoDataRow >
      <td class="mat-cell" colspan="4">No se encontraron datos</td>
    </tr>
  
    <tr mat-header-row *matHeaderRowDef="objectKeys(columnHeader)"></tr>
    <tr mat-row *matRowDef="let row; columns: objectKeys(columnHeader)" 
                [ngClass]="{'alarmed-row': row['statusAlarm'] === 'Alarmed', 'standby-row': row['statusAlarm'] === 'StandBy', 'inactiveUser': isInactive}"></tr>
  </table>
</div>

<mat-paginator 
  [pageSize]="10"
  [length]="mainTotalCount"
  (page)="nextPage($event)"
></mat-paginator>

<mat-menu #filterMenu="matMenu">
  <!-- Campo de entrada para filtrar las opciones -->
  <div style="padding: 3px;" (click)="$event.stopPropagation()">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Buscar</mat-label>
      <input matInput [(ngModel)]="filterSearchText" placeholder="Escribe para filtrar"  />
    </mat-form-field>
  </div>

  <!-- opcion de limpiado -->
  <button mat-menu-item (click)="clearColumnFilter()">---Limpiar---</button>

  <!-- se usa un pipe con la cadena del buscador para traer el array dinámico  -->
  <ng-container *ngFor="let option of (filterOptions[currentColumn] | filterArray: filterSearchText)">
    <button mat-menu-item (click)="applyColumnFilter(option)">{{ option }}</button>
  </ng-container>
</mat-menu>